function PlnomocenstvoSignatureHTMLRenderer(values) {
  let returnValue = '';
  if (
    values &&
    values['plnomocenstvo_header_custom'] &&
    Array.isArray(values['plnomocenstvo_header_custom']) &&
    values['plnomocenstvo_header_custom'].length > 0
  ) {
    let index = 0;
    returnValue += `<div style="display: flex; justify-content: space-between">`
    returnValue += "<div>"
    returnValue += `<h4> </h4><p class="ql-align-left">V Bratislave, dňa ...............................</p></br></br>`
    returnValue += `<p class="ql-align-left">..........................................</br>JUDr. Ondrej Matejka</p>`
    returnValue += `<p class="ql-align-left">konateľ advokátskej kancelárie</br>Matejka Friedmannová s. r. o.</p>`
    returnValue += "</div>"
    returnValue += "<div>"
    for (let representingPerson of values['plnomocenstvo_header_custom']) {
      returnValue += `<h4> </h4><p class="ql-align-right">V........................., dňa ...............................</p></br></br>`;
      returnValue += `<p class="ql-align-right">..........................................</br>${values.company.meno.value}</p>`;
      returnValue += `<p class="ql-align-right">${representingPerson}</p></p>`;
      returnValue += `<p class="ql-align-right">(úradne osvedčený podpis)</p></br></br>`;
      index += 1;
    }
    returnValue += "</div>"
    returnValue += "</div>"
  }

  if (returnValue !== '') {
    return returnValue
  }
}

function SignatureValidator(values) {
  if (
    values &&
    values['plnomocenstvo_header_custom'] &&
    Array.isArray(values['plnomocenstvo_header_custom']) &&
    values['plnomocenstvo_header_custom'].length > 0
  ) {
    for (let representingPerson of values['plnomocenstvo_header_custom']) {
      if (!representingPerson) {
        return false
      }
    }
  } else {
    return false
  }
  return true
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  HTMLRenderer: PlnomocenstvoSignatureHTMLRenderer,
  Validator: SignatureValidator
};
